import { render, staticRenderFns } from "./recipe-result.vue?vue&type=template&id=9193ace2&scoped=true&"
import script from "./recipe-result.vue?vue&type=script&lang=js&"
export * from "./recipe-result.vue?vue&type=script&lang=js&"
import style0 from "./recipe-result.vue?vue&type=style&index=0&id=9193ace2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9193ace2",
  null
  
)

export default component.exports